import Repository from "@/services/repository";

export default {
  updatePage(studyId, keywordId, url) {
    return Repository.put(`/a/${studyId}/keywords/${keywordId}/page.json`, {
      url,
    }).then((response) => response.data);
  },
};
